import Component from '@glimmer/component'
import RouteTemplate from 'ember-route-template'
import BookingAbandonmentCloseButton from 'customer-flows/components/flow-kit/booking-abandonment/close-button'
import BookingAbandonmentUnloadGuard from 'customer-flows/components/flow-kit/booking-abandonment/unload-guard'
import { service } from '@ember/service'
import { context } from 'customer-flows/utils/core'
import { pageTitle } from 'ember-page-title';
import enterDemoOnShiftClick from 'customer-flows/demo/modifiers/enter-demo-on-shift-click'
import DemoBanner from 'customer-flows/demo/components/banner'

class BookingTemplate extends Component {
  @service frameManager: FrameManager

  @context('account') availabilityBrandingConfig: AccountStore['availabilityBrandingConfig']
  @context('application') loading: ApplicationStore['loading']
  @context('activity') name: ActivityStore['name']

  get pageTitle() {
    return this.name ?? 'Booking Flow'
  }

  get showCloseButton() {
    return this.frameManager.isInFrame && !this.frameManager.isEmbed
  }

  <template>
    {{pageTitle this.pageTitle}}

    <BookingAbandonmentUnloadGuard />

    <div data-testid='booking-flow-container' class='mx-auto my-0 flex h-full w-full flex-col'>
      <div data-testid='booking-flow-container__header' class='sticky top-0 z-20 @md/flow:static'>
        <il-page-header
          {{enterDemoOnShiftClick}}
          logoUrl={{this.availabilityBrandingConfig.headerLogoUrl}}
          logoLabel={{this.availabilityBrandingConfig.headerText}}
          headerStyle={{this.availabilityBrandingConfig.headerStyle}}
        >
          <div slot='right-side'>
            {{#if this.showCloseButton}}
              <BookingAbandonmentCloseButton data-testid='booking-flow-container__close-button' />
            {{/if}}
          </div>
        </il-page-header>
      </div>

      <DemoBanner />

      {{#if this.loading}}
        <div data-testid='flow__loading-indicator' class='flex h-full w-full items-center justify-center py-10'>
          <il-loader />
        </div>
      {{else}}
        <div class='flex-1'>
          {{outlet}}
        </div>
      {{/if}}

    </div>
  </template>
}

export default RouteTemplate(BookingTemplate)
